import React from 'react';
import {Container, TextField, Button } from "@material-ui/core";

const RegisterInfo = () => (
    <Container maxWidth={'sm'}>div 1
    </Container>
);

export default RegisterInfo;
